export function webappDetail(data) {
    if (/(Android)/i.test(navigator.userAgent)) { //判断是否安卓app
      try {
        appDetail.postMessage(data);
      } catch (error) {
        console.log('原生app不存在appDetail方法');
      }
    } else { //ios App
      if (typeof appDetail == 'function') { //ios 老的webview调用方式
        try {
          appDetail(data);
        } catch (error) {
          console.log('原生app不存在appDetail方法');
        }
      } else { //新的webview调用方式
        try {
          window.webkit.messageHandlers.appDetail.postMessage(data);
        } catch {
          console.log('原生app不存在appDetail方法');
        }
      }
    }
  }
  
  export function webAppLogout() {
    if (window.jsObj) { //判断是否安卓app
      window.jsObj.appLogout();
    } else { //ios App
      if (typeof appLogout == 'function') { //ios 老的webview调用方式
        appLogout();
      } else { //新的webview调用方式
        try {
          window.webkit.messageHandlers.appLogout.postMessage('');
        } catch {
          console.log('原生app不存在appDetail方法');
        }
      }
    }
  }
  